export enum ESignatureLocalStorageKeys {
    RETURN_ROUTE = '_eSign-returnRoute',
    FLOW = '_eSign-flow',
    STEP = '_eSign-step',
}
